import {useState} from 'react';
import {cn} from '@continuum/ui';
import icAi from '~/assets/images/ic-ai.png';
import type {OrganizationInfo} from '~/lib/api';
import {useVerificationFlow} from './use-verification-flow';
import {EmailStep, OtpStep} from './steps';

interface VerificationOverlayProps {
  organization?: OrganizationInfo;
}

export function VerificationOverlay({organization}: VerificationOverlayProps) {
  const {step, email, isLoading, error, submitEmail, submitOtp, resendCode} =
    useVerificationFlow();

  const [logoFailed, setLogoFailed] = useState(false);

  const logoUrl = organization?.logoUrl ?? null;
  const organizationName = organization?.name ?? '';
  const shouldShowLogo = logoUrl !== null && !logoFailed;

  return (
    <div className={cn('fixed inset-0 z-50', 'flex flex-col bg-background')}>
      <div className="flex flex-1 items-center justify-center px-6">
        <div className="w-full max-w-sm flex flex-col items-center gap-4">
          {shouldShowLogo ? (
            <img
              src={logoUrl}
              alt={organizationName}
              className="max-h-20 w-auto object-contain"
              onError={() => setLogoFailed(true)}
            />
          ) : (
            <img src={icAi} alt="" className="size-10" />
          )}

          {step === 'email' ? (
            <EmailStep
              isLoading={isLoading}
              error={error}
              onSubmit={submitEmail}
            />
          ) : (
            <OtpStep
              email={email}
              isLoading={isLoading}
              error={error}
              onSubmit={submitOtp}
              onResend={resendCode}
            />
          )}
        </div>
      </div>
      <footer className="py-6 text-center text-sm text-muted-foreground">
        Powered by{' '}
        <a
          href="https://oncontinuum.com/"
          target="_blank"
          rel="noopener noreferrer"
          className="text-foreground underline-offset-4 hover:underline"
        >
          Continuum
        </a>
      </footer>
    </div>
  );
}
